import React, { useState } from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

const writingItems = [
  { year: '2024', title: 'Dis(a)ssociations', venue: 'The Feminisms of our Mothers — Zubaan Books', link: 'https://zubaanbooks.com/shop/the-feminisms-of-our-mothers/' },
  { year: '2024', title: 'Will I Ever Learn How to Cook?', venue: 'Astana Magazine', link: 'https://astana.design/will-i-ever-learn-how-to-cook' },
  { year: '2023', title: 'Exploring Gender through Psychedelics in Pakistan', venue: 'Expanding Mindscapes — MIT Press', link: 'https://direct.mit.edu/books/oa-edited-volume/5697/chapter/4411955/Tripping-in-Karachi-Exploring-the-Intersection-of' },
  { year: '2020', title: 'The Digital Fight for Transgender Rights in Pakistan', venue: 'Digital Rights Monitor', link: 'https://digitalrightsmonitor.pk/viral-videos-versus-structural-discrimination-the-digital-fight-for-trans-rights-in-pakistan/' },
  { year: '2020', title: 'Reporting and Environmental Awareness Music Festival in Pakistan', venue: 'Dialogue Earth', link: 'https://dialogue.earth/en/nature/at-the-lahooti-melo-it-is-ego-not-eco/' },
  { year: '2019', title: 'The Past, Present, and Future of Feminist Activism in Pakistan', venue: 'Herald Magazine', link: 'https://herald.dawn.com/news/1398878/the-past-present-and-future-of-feminist-activism-in-pakistan' },
  { year: '2019', title: 'In Pursuit of Altered States of Consciousness', venue: 'Herald Magazine', link: 'https://herald.dawn.com/news/1398753' },
  { year: '2018', title: 'My Walk Through Polycystic Ovary Syndrome', venue: 'Dawn Images', link: 'https://images.dawn.com/news/1183888/my-walk-through-polycystic-ovary-syndrome' },
];

const photographyEmbeds = [
  'https://www.instagram.com/p/CQktckWrvRo/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/p/CQksysdrHdN/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/p/CQksmR0L5bo/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/p/CU4RbqLFKvH/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/p/CUD1-0ornw5/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/p/CfN4p9fMQ9d/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
];

const campaignStats = [
  { value: '50k+', label: 'Followers' },
  { value: '250k+', label: 'Likes' },
  { value: '7k+', label: 'Comments' },
  { value: '40K+', label: 'Audiences reached' },
];

const filters = [
  { id: 'writing', label: 'Writing' },
  { id: 'photography', label: 'Photography' },
  { id: 'campaigns', label: 'Campaigns' },
];

const PortfolioGrid = () => {
  const [activeFilter, setActiveFilter] = useState('writing');

  return (
    <section id="portfolio" className="bg-bg-primary px-10 py-10" style={{ borderBottom: '0.5px solid #e0ddd8' }}>
      <span className="section-label">Writing & Work</span>

      {/* Tab bar */}
      <div className="flex gap-6 mb-8" style={{ borderBottom: '0.5px solid #e0ddd8', paddingBottom: '0' }}>
        {filters.map((f) => (
          <button
            key={f.id}
            onClick={() => setActiveFilter(f.id)}
            className="font-inter text-muted hover:text-ink transition-colors duration-200 bg-transparent border-none cursor-pointer pb-3"
            style={{
              fontSize: '12px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              borderBottom: activeFilter === f.id ? '1.5px solid #993C1D' : '1.5px solid transparent',
              color: activeFilter === f.id ? '#993C1D' : undefined,
              marginBottom: '-0.5px',
            }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Writing tab */}
      {activeFilter === 'writing' && (
        <div>
          {writingItems.map((item, i) => (
            <div
              key={i}
              className="flex gap-6 py-4 items-baseline"
              style={{ borderBottom: i < writingItems.length - 1 ? '0.5px solid #e0ddd8' : 'none' }}
            >
              <span
                className="text-terracotta font-inter flex-shrink-0"
                style={{ fontSize: '12px', minWidth: '36px' }}
              >
                {item.year}
              </span>
              <div>
                {item.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-playfair text-ink hover:text-terracotta transition-colors duration-200"
                    style={{ fontSize: '14px', lineHeight: 1.4, display: 'block', marginBottom: '3px' }}
                  >
                    {item.title}
                  </a>
                ) : (
                  <p className="font-playfair text-ink" style={{ fontSize: '14px', lineHeight: 1.4, marginBottom: '3px' }}>
                    {item.title}
                  </p>
                )}
                <p className="text-muted font-inter" style={{ fontSize: '12px', fontStyle: 'italic' }}>
                  {item.venue}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Photography tab */}
      {activeFilter === 'photography' && (
        <div>
          <p className="text-muted font-inter mb-6" style={{ fontSize: '13px', lineHeight: 1.6 }}>
            Documentary and street photography across South Asia and North America.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {photographyEmbeds.map((url, i) => (
              <div key={i} style={{ border: '0.5px solid #e0ddd8' }}>
                <InstagramEmbed url={url} width="100%" />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Campaigns tab */}
      {activeFilter === 'campaigns' && (
        <div style={{ border: '0.5px solid #e0ddd8', padding: '2rem' }}>
          <p
            className="text-terracotta font-inter mb-3"
            style={{ fontSize: '10px', letterSpacing: '0.15em', textTransform: 'uppercase' }}
          >
            Digital Campaign
          </p>
          <p className="font-playfair text-ink mb-2" style={{ fontSize: '20px', lineHeight: 1.3 }}>
            PEN America TikTok Campaign
          </p>
          <p className="text-muted mb-6" style={{ fontSize: '13px', lineHeight: 1.7 }}>
            Built and managed PEN America's TikTok presence to amplify advocacy against book bans and censorship. Created content that reached and mobilised 40K+ international audiences across platforms.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
            {campaignStats.map((stat, i) => (
              <div key={i} className="bg-bg-secondary p-4" style={{ borderRadius: '2px' }}>
                <p className="font-playfair text-ink" style={{ fontSize: '20px' }}>{stat.value}</p>
                <p className="text-muted font-inter" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{stat.label}</p>
              </div>
            ))}
          </div>
          <p className="text-muted font-inter" style={{ fontSize: '11px', letterSpacing: '0.05em' }}>
            New York, 2022–24
          </p>
        </div>
      )}
    </section>
  );
};

export default PortfolioGrid;
